export { default as makeActionCreator } from './actionCreator';
export { default as makeAsyncActionCreator } from './asyncActionCreator';



export function closest(el, cls) {
  while (el) {
    if (el.classList.contains(cls)) return el
    else el = el.parentElement
  }
}

export function findMeorAncestor(el, cls) {
  while (!el.classList.contains(cls) && (el = el.parentElement)) {
    return el
  }
}



// WEBPACK FOOTER //
// /var/www/build-health-2/src/utils/index.js